
export function UnauthorisedAcess(params) {
    return(
        <div>Access Denied - You don't have permission to access this page</div>
    );
}